<template>
  <virtual-tree
    :data="originTree"
    :checked="checked"
    @change="checkedChange"
    :clearable="clearable"
    :props="customProps"
    :showDelete="filterDelete"
    :placeholder="$attrs.placeholder ||`请选择组织机构`"
    :multiple="multiple"
    v-bind="$attrs"
  ></virtual-tree>
</template>

<script>
import { mapGetters } from 'vuex'
import virtualTree from './virtualTree'
export default {
  name: 'yblSelectTree',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    items: {
      type: Array | Object,
      default: () => []
    },
    treeList: { // 组件数据源，有值时不请求数据
      type: Array,
      default: () => []
    },
    checked: {
      type: Array | String,
      default: () => []
    },
    props: {
      type: Object,
      default () {
        return {
          label: 'Label',
          id: 'Value',
          parentId: 'ParentId',
          status: 'Status',
          statusValue: '-1',
          isTree: false,
          cancelText: '已注销', // 取消文本（显示在节点上）
          cancelField: 'Logout',
          cancelValue: 'true' // 8 注销状态 Logout=true
        }
      }
    },
    filterDelete: { // 筛选是否显示已删除的机构
      type: Boolean,
      default: () => true
    },
    isHuman: { // 是否人管组织机构信息
      type: Boolean,
      default: () => false
    },
    isLifeInsurance: { // 是否寿险机构信息
      type: Boolean,
      default: () => false
    },
    filterType: { // 是否只显示组织数据
      default: () => ''
    },
    configValue: { // 已选择配置的组织机构值（主要应用于非车政策）
      type: Array | String,
      default: () => []
    },
    showStyle: { // 人管组织机构 展示风格 1：平级 2：层级
      type: Number,
      default: () => 1
    },
    partnerId: { // 商户id，不传查当前登录商户，传查此条数据对应商户
      type: Number | String,
      default: () => ''
    },
    checkedChild: { // 是否选中子机构
      type: Boolean,
      default: () => false
    },
    disableList: { // 禁用数据
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: '',
      checkStrictly: true,
      filterText: '',
      isFilter: false,
      effectiveData: [],
      originTreeData: [],
      originTree: [],
      originOrganization: [],
      defaultCheckedKeys: [], // 默认选中项目
      dynamicKey: {} // 存储机构递归的父级的键值对信息
    }
  },
  created () {
    if (this.treeList && this.treeList.length > 0) {
      this.originTree = this.dealTreeData(this.treeList)
    } else {
      this.initOrganization().then(data => {
        this.originTree = this.dealTreeData(data.datas || [])
      })
    }
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER'
    ]),
    authorizedOrganizationIds () {
      return this.CUSTOMER_LOGINCUSTOMER && this.CUSTOMER_LOGINCUSTOMER.data && this.CUSTOMER_LOGINCUSTOMER.data.AuthorizedOrganizationIds
    },
    clearable () {
      return this.$attrs.clearable === undefined ? true : this.$attrs.clearable
    },
    multiple () {
      return this.$attrs.showCheckbox
    },
    readonly () {
      return this.$attrs.readonly || false
    },
    customProps () {
      const { cancelField, ...props } = this.props
      const dynamicProps = {}
      if (cancelField) {
        dynamicProps['cancelField'] = this.isHuman ? cancelField.toLowerCase() : cancelField
      }

      return {
        ...props,
        ...dynamicProps
      }
    }
  },
  components: {
    virtualTree
  },
  methods: {
    dealTreeData (data) {
      const _this = this
      let disables = this.disableList.map(c => { return +c.organizationId })
      return data.map(item => ({
        ...item,
        disabled: disables.includes(+item[this.props.id]),
        readonly: _this.readonly ? true : (_this.isHuman ? item.showStatus === -1 : _this.checkItemReadOnly(item))
      }))
    },
    checkedChange (value, item) {
      console.log('🚀 ~ file: SelectTree.vue:131 ~ checkedChange ~ value:', value, item)
      this.$emit('change', value, item)
    },
    getSmallOrganization () {
      let params = {
        filterType: this.isLifeInsurance ? 1 : ''
      }
      return this.$store.dispatch('customerGetSmallOrganization', params).then(data => {
        return data
      })
    },
    gainOrganization () {
      let params = {
        showStyle: this.showStyle, // 展示风格 1：平级 2：层级
        filterType: this.filterType,
        partnerId: this.partnerId
      }
      return this.$store.dispatch('sysBranchOrgGetSysOrgComInfo', params).then(data => {
        return data
      })
    },
    arrayToTree (data) {
      const result = []
      const itemMap = {}
      for (const item of data) {
        const id = item[this.props.id]
        const pid = item[this.props.parentId]

        if (!itemMap[id]) {
          itemMap[id] = {
            children: []
          }
        }

        itemMap[id] = {
          ...item,
          children: itemMap[id]['children']
        }

        const treeItem = itemMap[id]
        if (+pid === 0) {
          result.push(treeItem)
        } else {
          if (!itemMap[pid]) {
            itemMap[pid] = {
              children: []
            }
          }
          itemMap[pid].children.push(treeItem)
        }
      }
      return result
    },
    initOrganization () {
      return this.isHuman ? this.gainOrganization() : this.getSmallOrganization()
    },
    checkItemReadOnly (item) {
      const { id } = this.props
      let readOnly = !(this.authorizedOrganizationIds || '').split(',').includes(`${item[id]}`)
      if (this.configValue && this.configValue.length > 0) {
        const _configValue = Array.isArray(this.configValue) ? this.configValue : ((this.configValue || '').split(','))
        readOnly = readOnly || !_configValue.includes(`${item[id]}`)
      }
      return readOnly
    }
  },
  watch: {
    'disableList': function (newVal) {
      let disables = newVal.map(c => { return +c.organizationId })
      console.log('disableList change', disables)
      this.originTree = this.originTree.map(item => ({
        ...item,
        disabled: disables.includes(+item[this.props.id]),
        readonly: this.readonly ? true : (this.isHuman ? item.showStatus === -1 : this.checkItemReadOnly(item))
      }))
      console.log('this.originTree', this.originTree)
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/SelectTree.vue